import React from 'react';

import styles from './DeliveryMethod.module.css'
import {cn} from "../../../../../../../utils/cn.ts";
import {Icon} from "../../../../../../../ui/General/Icon/Icon.tsx";
import {DeliveryType} from "../../../../../../../types/Delivery.interface.ts";
import {Order} from "../../../../../../../types/Order.interface.ts";

interface Props {
    deliveryType: string,
    offer: Order,
}

export const DeliveryMethods: React.FC<Props> = ({deliveryType, offer}) => {
    const isPodzamenuPickup = deliveryType === DeliveryType.pickup
    const isOthers = deliveryType === DeliveryType.shipping;

    return (<ul className={styles.deliveryMethods}>
        <li
            className={cn(
                styles.deliveryMethod,
                isPodzamenuPickup && styles.deliveryMethodChosen
            )}
        >
            <Icon className={styles.deliveryMethodIcon} name='geo-marker' width={23} height={31}
                  color={isPodzamenuPickup ? '#F39200' : '#cdcdcd'}/>
            <div className={cn(styles.deliveryMethodTitle, isPodzamenuPickup && styles.deliveryMethodTitleChosen)}>
                Самовывоз
            </div>
            <div className={styles.deliveryMethodInfo}>
                {offer.accessibilityBranches.length} ПВ
            </div>
        </li>

        <li
            className={cn(
                styles.deliveryMethod,
                isOthers && styles.deliveryMethodChosen
            )}
        >
            <Icon className={styles.deliveryMethodIcon} name='box' width={23} height={31}
                  color={isOthers ? '#F39200' : '#cdcdcd'}/>
            <div
                className={cn(styles.deliveryMethodTitle, isOthers && styles.deliveryMethodTitleChosen)}>
                Транспортная компания
            </div>
            <div className={styles.deliveryMethodInfo}>
                Рассчитать доставку
            </div>
        </li>
    </ul>);
};